import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useBlackFridayStore } from 'store/context'
import styled from 'styled-components'
import { baseCss } from 'uiComponents/atoms/Text/Headings'
import { primaryColor } from 'uiComponents/constants/colors'
import {
  fsL,
  fsM,
  fsS,
  fsXS,
  fsXXS,
  fwMediumBold,
} from 'uiComponents/constants/typography'

const BlackFridayTextContainer = styled('div')`
  display: flex;
  max-width: 1024px;
  margin: 12px auto;
  padding: 0 24px;

  h1 {
    ${baseCss};
    font-size: ${fsS}px;
    line-height: ${fsL}px;
    padding: 40px 0 15px;
  }
  h2 {
    ${baseCss};
    font-size: ${fsXS}px;
    line-height: ${fsM}px;
    padding: 15px 0 8px;
  }
  h3 {
    ${baseCss};
    font-size: ${fsXS}px;
    padding: 8px 0;
    ${fwMediumBold};
  }
  ul {
    ${baseCss};
    padding: 6px 0;
  }
  li {
    ${baseCss};
    padding: 2px 0;
    color: ${primaryColor};
    ${fwMediumBold};
    font-size: ${fsXXS}px;
  }
  p {
    font-size: ${fsXXS}px;
  }
`

const SeoText: React.FunctionComponent = () => {
  const blackFridayStore = useBlackFridayStore()
  const { placeholders } = useObserver(() => blackFridayStore)

  return (
    <BlackFridayTextContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: `${placeholders['{{BF-LP-SEOTEXT}}']} ${placeholders['{{BF-LP-BRANDS}}']}`,
        }}
      />
    </BlackFridayTextContainer>
  )
}

export default SeoText
